export const rankingData = [
  { id: 1, title: '某顶流男星深夜与神秘女子同回公寓，粉丝集体破防', hot: '98.7万', tag: '爆', time: '2小时前' },
  { id: 2, title: '知名女星离婚内幕曝光，男方疑似婚内转移财产', hot: '86.3万', tag: '热', time: '4小时前' },
  { id: 3, title: '网红主播被实锤数据造假，品牌方连夜解约索赔千万', hot: '72.1万', tag: '热', time: '6小时前' },
  { id: 4, title: '某综艺录制现场冲突升级，两位导师当场互撕', hot: '65.8万', tag: '新', time: '8小时前' },
  { id: 5, title: '选秀出道组被曝团体内部霸凌，C位成员发声回应', hot: '54.2万', tag: '新', time: '10小时前' },
];

export const topicsData = [
  { id: 1, name: '#某顶流恋情曝光', heat: '238万讨论', trend: 'up' },
  { id: 2, name: '#明星离婚风波', heat: '186万讨论', trend: 'up' },
  { id: 3, name: '#综艺录制冲突', heat: '152万讨论', trend: 'hot' },
  { id: 4, name: '#网红造假实锤', heat: '129万讨论', trend: 'up' },
  { id: 5, name: '#女团内部霸凌', heat: '108万讨论', trend: 'new' },
  { id: 6, name: '#某导演潜规则', heat: '95万讨论', trend: 'up' },
  { id: 7, name: '#配音演员塌房', heat: '87万讨论', trend: 'new' },
  { id: 8, name: '#品牌连夜解约', heat: '73万讨论', trend: 'hot' },
  { id: 9, name: '#电竞圈新瓜', heat: '68万讨论', trend: 'new' },
];

export const appData = {
  title: '吃瓜每日大赛 APP',
  subtitle: '下载 APP 随时吃瓜 · 一手爆料快人一步',
  description: '实时推送热门爆料，离线也能看、不遗漏任何一个大瓜。支持 iOS 与 Android，每日更新独家黑料内容。',
  features: ['7×24 实时推送', '独家深度爆料', '离线浏览模式', '弹幕吃瓜互动'],
};

export const aboutData = {
  title: '关于吃瓜每日大赛',
  description: '吃瓜每日大赛创立于 2020 年，是国内领先的娱乐圈八卦与网红爆料聚合平台。我们拥有覆盖全网的专业采编团队，坚持「客观还原真相、理性看待八卦」的运营理念，为用户提供第一手吃瓜最新爆料与今日黑料资讯。',
  stats: [
    { value: '500万+', label: '月活跃吃瓜群众' },
    { value: '2万+', label: '累计爆料稿件' },
    { value: '98.6%', label: '爆料准确率' },
    { value: '30+', label: '专业娱记团队' },
  ],
};

export const contactData = {
  title: '爆料投稿 & 商务合作',
  subtitle: '你有猛料？我们来曝！',
  description: '欢迎广大吃瓜群众提供线索，无论是娱乐圈瓜、网红八卦还是最新吃瓜事件，一经采纳必有重酬。商务合作请注明来意。',
  email: 'tips@chigua365.com',
  wechat: 'ChiguaDaily365',
  responseTime: '投稿后 24 小时内必有回音',
};

export const cardsData = [
  {
    id: 1,
    title: '深扒：某流量小生背后的资本运作与资源置换内幕',
    excerpt: '从籍籍无名到顶流之巅，短短三年间资源飞升的背后，隐藏着怎样不为人知的资本交易？我们独家调查了...',
    category: '深度爆料',
    time: '3小时前',
    views: '128万',
    imageSeq: 'card-01',
    imageQuery: 'A dramatic red curtain partially revealing a shadowy figure in the spotlight on a dark stage, cinematic noir style photography with warm amber lighting and deep shadows, theatrical composition, mysterious atmosphere, editorial quality',
  },
  {
    id: 2,
    title: '某知名女团成员被曝与经纪公司对簿公堂，合约纠纷全梳理',
    excerpt: '合约即将到期之际，双方因续约条件产生严重分歧。成员控诉公司霸王条款，公司反指成员违约在先...',
    category: '娱乐圈瓜',
    time: '5小时前',
    views: '96万',
    imageSeq: 'card-02',
    imageQuery: 'A lone microphone stand on an empty concert stage with dramatic spotlight from above, backstage theatrical atmosphere, warm golden light rays piercing through darkness, poetic composition, editorial photography style with soft film grain',
  },
  {
    id: 3,
    title: '直播带货翻车现场：某大主播售卖假货被消费者集体维权',
    excerpt: '号称"全网最低价"的名牌包包经鉴定为高仿，消费者联盟已聘请律师准备发起集体诉讼...',
    category: '网红八卦',
    time: '7小时前',
    views: '85万',
    imageSeq: 'card-03',
    imageQuery: 'A close-up of scattered luxury shopping bags on a marble floor with dramatic side lighting, some bags torn open revealing counterfeit items, investigative journalism style, warm and cool contrast lighting, high detail editorial photography',
  },
  {
    id: 4,
    title: '某知名导演被多名演员联合举报，剧组内部聊天记录流出',
    excerpt: '三位曾与其合作的女演员同时发声，指控其在片场的不当行为。内部工作人员提供的聊天记录显示...',
    category: '今日黑料',
    time: '9小时前',
    views: '203万',
    imageSeq: 'card-04',
    imageQuery: 'A vintage film clapperboard lying cracked on a wooden floor with scattered torn script pages around it, dim atmospheric lighting with a single warm desk lamp, cinematic noir aesthetic, mysterious and dramatic composition, editorial quality',
  },
  {
    id: 5,
    title: '某综艺节目后期剪辑师匿名爆料：节目组恶意剪辑制造话题',
    excerpt: '一段未播出的原始素材被匿名曝光，与播出画面对比后惊人发现：嘉宾的真实表现被完全扭曲...',
    category: '吃瓜最新爆料',
    time: '11小时前',
    views: '67万',
    imageSeq: 'card-05',
    imageQuery: 'A professional video editing suite with multiple monitors showing colorful waveform patterns, red dramatic warning indicators on screen, dim blue ambient lighting creating a tense atmosphere, tech noir aesthetic, editorial photography style',
  },
];

export const updatesData = [
  {
    id: 1,
    time: '14:32',
    title: '某男星工作室发声明否认恋情传闻，称将追究造谣者法律责任',
    tag: '最新回应',
  },
  {
    id: 2,
    time: '13:15',
    title: '综艺节目组就录制冲突事件发布致歉声明，宣布暂停录制一周',
    tag: '官方通报',
  },
  {
    id: 3,
    time: '11:48',
    title: '品牌方官宣：正式与涉造假主播解除全部合作关系，保留追诉权利',
    tag: '品牌解约',
  },
  {
    id: 4,
    time: '10:20',
    title: '女团经纪公司连夜开会，涉事成员暂停一切公开活动',
    tag: '紧急处理',
  },
  {
    id: 5,
    time: '09:05',
    title: '多位圈内人士转发声援，呼吁行业建立反霸凌公约',
    tag: '行业动态',
  },
  {
    id: 6,
    time: '07:30',
    title: '昨夜某颁奖典礼后台画面曝光，两位视后零交流引猜测',
    tag: '现场直击',
  },
  {
    id: 7,
    time: '06:12',
    title: '凌晨突发：某知名音乐人被拍到出入警局，原因成谜',
    tag: '突发',
  },
  {
    id: 8,
    time: '03:45',
    title: '海外媒体爆料某华裔演员在好莱坞遭遇歧视，引发海外热议',
    tag: '国际瓜',
  },
];

export const mediaData = [
  {
    id: 1,
    title: '独家专访：前经纪人员工揭秘娱乐圈潜规则内幕',
    duration: '18:42',
    views: '256万',
    thumbnailSeq: 'media-01',
    thumbnailQuery: 'A silhouetted figure sitting in a dim interview room with a single warm overhead light creating dramatic shadows, documentary interview aesthetic, anonymous source atmosphere, high contrast black and warm tones, cinematic composition, editorial photography',
  },
  {
    id: 2,
    title: '现场直击：品牌解约发布会全场实录，法务团队详解维权',
    duration: '12:15',
    views: '189万',
    thumbnailSeq: 'media-02',
    thumbnailQuery: 'A press conference podium with multiple microphones under bright stage lights, empty audience chairs in shadow, formal announcement atmosphere, warm spotlight on the podium, journalistic photography style, high detail editorial quality',
  },
  {
    id: 3,
    title: '深度解析：近五年娱乐圈重大爆料事件时间线全回顾',
    duration: '25:08',
    views: '321万',
    thumbnailSeq: 'media-03',
    thumbnailQuery: 'An artistic wall installation with interconnected red strings connecting photographs and newspaper clippings like an investigation board, warm ambient lighting, documentary investigation aesthetic, editorial photography, high detail composition',
  },
];

export const carouselData = [
  {
    id: 1,
    title: '娱乐圈2026上半年十大爆料事件全景回顾',
    excerpt: '从年初的顶流恋情曝光到暑期的综艺冲突升级，我们梳理了今年上半年最震撼的十大吃瓜事件及其后续发展。',
    label: '年度盘点',
    imageSeq: 'carousel-01',
    imageQuery: 'An artistic composition of floating newspaper headlines and breaking news graphics in warm red and gold tones, abstract journalistic collage style, editorial design aesthetic, dramatic lighting, high detail contemporary art photography',
  },
  {
    id: 2,
    title: '深扒网红经济背后的灰色产业链',
    excerpt: '数据造假、刷单炒信、虚假人设——网红经济的繁荣表象下，究竟隐藏着多少不为人知的操作？',
    label: '调查报道',
    imageSeq: 'carousel-02',
    imageQuery: 'A dramatic close-up of a smartphone screen displaying glowing social media metrics with shadowy hands manipulating data behind it, dark background with warm amber warning highlights, investigative tech-noir aesthetic, editorial photography',
  },
  {
    id: 3,
    title: '配音演员圈连环塌房始末：从神坛到谷底',
    excerpt: '一个月内五位知名配音演员接连被曝负面新闻，这个曾经被视为娱乐圈清流的群体为何集体崩塌？',
    label: '专题追踪',
    imageSeq: 'carousel-03',
    imageQuery: 'A vintage radio studio microphone with a cracked housing standing alone in spotlight, crumbling pedestal beneath it, dramatic theatrical lighting with warm gold and deep shadow, symbolic composition, cinematic editorial photography',
  },
  {
    id: 4,
    title: '吃瓜群众生存指南：如何理性看待娱乐圈爆料',
    excerpt: '在这个信息爆炸的时代，每天都有无数瓜从天而降。我们整理了一份实用的吃瓜指南，教你分辨真假爆料。',
    label: '用户指南',
    imageSeq: 'carousel-04',
    imageQuery: 'A pair of reading glasses resting on an open notebook with a red pen, beside a steaming cup of tea, warm cozy reading nook atmosphere, soft natural window light, intellectual lifestyle photography, editorial quality with warm amber tones',
  },
];

export const faqData = [
  {
    q: '吃瓜每日大赛的爆料来源是否可靠？',
    a: '我们拥有严格的爆料审核机制，所有稿件均需经过采编团队交叉验证后方可发布。对于未经证实的传闻，我们会在标题和正文中明确标注「传闻」或「网传」字样。同时，我们的采编团队与多家娱乐经纪公司、影视剧组保持长期合作关系，确保信息来源的多样性和可靠性。',
  },
  {
    q: '如何向吃瓜每日大赛投稿爆料？',
    a: '您可以通过页面底部的「爆料投稿」入口提交线索，或直接发送邮件至 tips@chigua365.com。所有投稿均严格保密线人身份信息，一经采纳将根据爆料价值提供丰厚稿酬。我们承诺：保护线人，是我们最重要的底线。',
  },
  {
    q: '网站上报道的内容是否会涉及侵犯隐私？',
    a: '吃瓜每日大赛严格遵守相关法律法规，所有报道均基于公开信息和合法渠道获取。我们绝不非法获取个人隐私信息，也不报道与公共利益无关的私人生活细节。我们的报道聚焦于公众人物的公开行为、行业现象和社会议题。',
  },
  {
    q: '吃瓜每日大赛的更新频率是怎样的？',
    a: '我们保持 7×24 小时全天候更新，采编团队三班倒轮值，确保不漏掉任何一个重要爆料。重大突发事件将在 30 分钟内发布快讯，深度调查稿件每日至少更新 5 篇，话题榜单每小时刷新一次。',
  },
  {
    q: '如果报道内容有误，如何进行更正或申诉？',
    a: '我们设有专门的纠错与申诉通道。如果您发现报道中存在事实性错误，请通过「联系我们」页面提交更正申请，我们将在核实后 2 小时内完成更正并发布更正声明。如涉及名誉权等问题，可联系法务邮箱进行正式申诉。',
  },
  {
    q: '吃瓜每日大赛与普通娱乐媒体有什么不同？',
    a: '与传统的娱乐媒体不同，我们更注重「吃瓜群众」的参与感和互动性。我们不仅报道爆料，还会提供事件的全景梳理、多方观点对比和深度分析。同时，我们坚持不恶意炒作、不制造谣言、不煽动对立，致力于做最值得信赖的吃瓜第一站。',
  },
];

export const indexData = [
  {
    id: 1,
    title: '娱乐圈瓜',
    count: '1,286篇',
    description: '涵盖影视明星、歌手、综艺艺人等全方位娱乐圈最新动态与爆料',
  },
  {
    id: 2,
    title: '网红八卦',
    count: '967篇',
    description: '直播带货、短视频达人、社交媒体网红的最新八卦与争议事件',
  },
  {
    id: 3,
    title: '今日黑料',
    count: '542篇',
    description: '每日更新的重磅黑料与独家内幕，深度挖掘不为人知的真相',
  },
  {
    id: 4,
    title: '吃瓜最新爆料',
    count: '2,138篇',
    description: '实时追踪全网最新爆料动态，第一时间推送突发吃瓜事件',
  },
  {
    id: 5,
    title: '综艺真人秀',
    count: '876篇',
    description: '各大综艺节目幕后花絮、录制趣闻、选手争议与制作内幕',
  },
  {
    id: 6,
    title: '配音演员圈',
    count: '423篇',
    description: '配音演员行业动态、作品评价、圈内八卦与行业发展观察',
  },
  {
    id: 7,
    title: '电竞娱乐圈',
    count: '654篇',
    description: '电竞选手、游戏主播的八卦爆料、行业争议与跨界娱乐动态',
  },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '全网最快爆料',
    description: '7×24小时全天候追踪，重大突发事件30分钟内快讯上线，比同行平均快2小时以上。',
  },
  {
    id: 2,
    icon: 'ri-shield-check-line',
    title: '三重交叉验证',
    description: '每篇爆料稿件均经过采编初审、编辑部复核、法务终审三道关卡，杜绝虚假信息。',
  },
  {
    id: 3,
    icon: 'ri-user-voice-line',
    title: '线人严格保护',
    description: '投稿人身份信息采用银行级加密存储，绝不泄露任何线人信息，这是我们最核心的底线。',
  },
  {
    id: 4,
    icon: 'ri-emotion-happy-line',
    title: '千万吃瓜社区',
    description: '超过500万月活跃吃瓜群众，弹幕评论实时互动，吃瓜不再是一个人的狂欢。',
  },
];

export const commentsData = [
  {
    id: 1,
    name: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20watermelon%20character%20with%20big%20expressive%20eyes%20wearing%20sunglasses%2C%20cartoon%20style%2C%20minimal%20design%20on%20clean%20background%2C%20kawaii%20aesthetic&width=80&height=80&seq=avatar-01&orientation=squarish',
    time: '2小时前',
    content: '这个瓜太劲爆了！我从昨晚追到现在，每一个细节都让人震惊。感谢吃瓜每日大赛的第一手报道，比其他平台快太多了！',
    likes: 3289,
  },
  {
    id: 2,
    name: '理性吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20cartoon%20character%20of%20a%20person%20holding%20a%20magnifying%20glass%2C%20clean%20simple%20design%2C%20investigation%20theme%2C%20on%20plain%20background%2C%20editorial%20illustration%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    time: '3小时前',
    content: '作为老吃瓜群众，我觉得这篇深度调查写得很客观，没有站队任何一方，把各方说法都摆出来了。这才是专业的态度。',
    likes: 2156,
  },
  {
    id: 3,
    name: '娱乐圈观察者',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20cartoon%20character%20of%20a%20person%20with%20binoculars%2C%20clean%20simple%20design%2C%20observation%20theme%2C%20on%20plain%20background%2C%20editorial%20illustration%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    time: '5小时前',
    content: '关注你们三年了，亲眼看着从一个小号成长为头部吃瓜平台。质量一直很稳定，最关键的是不造谣不传谣，这在现在太难得了。',
    likes: 1892,
  },
];